import React, { memo, useContext } from 'react';
import Row from 'components/react-data-grid/Row';
import PropTypes from 'prop-types';
import ExpansionContext from '../Context/ExpansionContext';

const ExpandedRowRenderer = (props) => {
  const { openMap } = useContext(ExpansionContext);
  const expanded = openMap?.[props.row?.uuid];

  return (
    <div className="row-wrapper">
      <Row {...props} height={props.rowHeight} />
      {expanded ? props.expansion(props) : null}
    </div>
  );
};

ExpandedRowRenderer.propTypes = {
  expansion: PropTypes.func,
};

const areEqual = (prevProps, nextProps) => {
  return nextProps.row === prevProps.row;
};

export default memo(ExpandedRowRenderer, areEqual);
